import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import NewAboutHero from "./NewAboutHero";
import NewAboutWhoWeAre from "./NewAboutWhoWeAre";
import OurValues from "./OurValues";
import BoostBussiness from "./BoostBussiness";
import ScrollPathAnimation from "./ScrollPath";
import SmallScrollPath from "./SmallScrollPath";
import Creators from "../NewHomePage/Creators";
import Culture from "./Culture";

const NewAboutPage = () => {
  const [pageLoading, setPageLoading] = useState(true);

  const dataContext = useContext(AuthContext);

  useEffect(() => {
    // Set Page Title
    document.title = "About TechQilla | Digital Marketing Agency in India";

    // --- Description ---
    let metaDescription = document.querySelector<HTMLMetaElement>(
      "meta[name='description']",
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Learn about TechQilla, a results-driven digital marketing agency in India helping brands scale through technology, creativity, and data-driven strategies.",
    );

    // --- Keywords ---
    let metaKeywords = document.querySelector<HTMLMetaElement>(
      "meta[name='keywords']",
    );
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", "Digital Marketing Agency in India");
    // --- Canonical ---
    let linkTag = document.querySelector<HTMLLinkElement>(
      "link[rel='canonical']",
    );
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute("href", "https://www.techqilla.com/who-we-are");
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      setPageLoading(false);
    }, 10); // Simulate page render delay

    return () => clearTimeout(delay);
  }, []);

  if (pageLoading) return null;
  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`${theme === "dark" ? "" : ""} transition-all duration-500`}
    >
      <NewAboutHero />
      <NewAboutWhoWeAre />
      <OurValues />
      <BoostBussiness />
      <ScrollPathAnimation />
      <SmallScrollPath />
      <Creators />
      <div
        className={`${
          theme === "dark" ? "bg-primary" : "bg-[#141414]"
        } flex flex-col  items-center justify-center`}
      >
        <Culture />
      </div>
    </div>
  );
};

export default NewAboutPage;
